import { useEffect } from 'react'

const DEMO_STATE_PREFIXES = [
  'exchange_wizard_v1_',
  'sale_wizard_v1_',
  'exchange_wizard_',
  'sale_wizard_',
  'wizard_state_',
  'hub_status_',
  'hub_locked_',
  'pending_sync_',
  'escrow_data_',
  'escrow_step_',
  'identification_step_',
  'purchase_step_',
  'disbursement_step_',
  'document_',
  'esign_',
  'exchange_agreement',
  'user_saved_signature',
  'exchange_docs_',
  'user_activities',
  'property_sale_date',
  'calculator_savings',
  'calculator_results',
  'demo_activities_logged',
  'sales_hub_submitted',
  'identification_hub_submitted',
  'purchase_hub_submitted',
  'disbursement_hub_submitted',
  'acquisition_hub_submitted',
  'w9_',
  'kyc_modal_shown_',
  'sales_hub_phase1_step_',
  'user_data_cache',
  'open1031:calculator:',
  'open1031:docs:',
  'edit_tickets',
  'demo_unlock_all',
  'demo_identity_verified',
  'demo_reset_just_completed',
  'marketplace_favorites_',
]

const GLOBAL_DEMO_KEYS = [
  'sales_hub_submitted',
  'sales_hub_submitted_date',
  'identification_hub_submitted',
  'identification_hub_submitted_date',
  'escrow_hub_submitted',
  'escrow_hub_submitted_date',
  'purchase_hub_submitted',
  'purchase_hub_submitted_date',
  'acquisition_hub_submitted',
  'acquisition_hub_submitted_date',
  'disbursement_hub_submitted',
  'disbursement_hub_submitted_date',
  'exchange_agreement_signed',
  'exchange_agreement_data',
  'exchange_agreement_signed_date',
  'exchange_agreement_signed_by',
  'exchange_agreement_signature',
  'identification_hud1_uploaded',
  'identification_form_signed',
  'identification_form_signature',
  'identification_form_signed_date',
  'identification_form_signed_by',
  'w9_signed',
  'w9_signature',
  'w9_signed_date',
  'w9_signed_by',
  'demo_unlock_all',
  'demo_identity_verified',
  'demo_activities_logged',
  'demo_reset_just_completed',
  'property_sale_date',
  'calculator_results',
  'calculator_savings',
  'edit_tickets',
]

function syncedKey(exchangeId: string): string {
  return `demo_reset_synced_${exchangeId}`
}

export function clearDemoLocalStorage(exchangeId: string, userId: string): void {
  const allKeys = Object.keys(localStorage)
  const keysToRemove: string[] = []

  for (const key of allKeys) {
    const matchesPrefix = DEMO_STATE_PREFIXES.some(prefix => key.startsWith(prefix))
    if (matchesPrefix) {
      keysToRemove.push(key)
    }
  }

  keysToRemove.forEach(key => localStorage.removeItem(key))
  GLOBAL_DEMO_KEYS.forEach(key => localStorage.removeItem(key))

  localStorage.removeItem(`escrow_data_${userId}`)
  localStorage.removeItem(`open1031:calculator:${userId}`)
  localStorage.removeItem(`open1031:docs:${userId}`)
  localStorage.removeItem(`user_progress_${userId}`)

  localStorage.removeItem(syncedKey(exchangeId))
}

export function useDemoResetSync(
  exchangeId: string | undefined,
  demoResetAt: string | null | undefined,
  userId: string | undefined,
  onReset: () => void = () => window.location.reload()
): void {
  useEffect(() => {
    if (!exchangeId || !demoResetAt || !userId) {
      return
    }

    const syncedTimestamp = localStorage.getItem(syncedKey(exchangeId))

    if (syncedTimestamp && syncedTimestamp >= demoResetAt) {
      return
    }

    clearDemoLocalStorage(exchangeId, userId)
    localStorage.setItem(syncedKey(exchangeId), demoResetAt)
    window.dispatchEvent(new Event('demo.reset.completed'))
    onReset()
  }, [exchangeId, demoResetAt, userId, onReset])
}
